module.exports = __webpack_public_path__ + "img/42.7a397b17.png";